/*
 * @Author: your name
 * @Date: 2020-06-29 10:47:30
 * @LastEditTime: 2020-07-07 11:49:46
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \Parts_APP\src\permission.js
 */
import router from './router'
import store from './store'
// import { Message } from 'element-ui'
// import NProgress from 'nprogress' // progress bar
// import 'nprogress/nprogress.css' // progress bar style
import { getToken } from '@/utils/auth' // get token from cookie
// import getPageTitle from '@/utils/get-page-title'

// NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['/login'] // no redirect whitelist

router.beforeEach(async(to, from, next) => {
    // start progress bar
    // NProgress.start()

    // set page title
    // document.title = getPageTitle(to.meta.title)

    // determine whether the user has logged in
    const hasToken = getToken()
    console.log('this', hasToken)
    if (hasToken) {   
        if (to.path === '/login') {
            // if is logged in, redirect to the home page
            next({ path: '/' })
            // NProgress.done()
        } else {
            console.log(store.getters,'tore.getters')
            const hasGetUserInfo = store.getters.name
            console.log('app名', hasGetUserInfo)
            if (hasGetUserInfo && hasGetUserInfo !== '') {
                console.log('hasGetUserInfo:', 'kong')
                next()
            } else {
                console.log('hasGetUserInfo:', 'no kong')
                try {
                    await store.dispatch('user/getInfo').then(res => {
                        console.log('获取用户信息', res.data)
                        // store.dispatch('permission/generateRoutes').then(res => {
                        //     router.addRoutes(store.getters.routes)
                        //     store.dispatch('commonData/getAddressTree')
                        // })
                    })
                    // NProgress.done()
                    next()
                } catch (error) {
                    // remove token and go to login page to re-login
                    await store.dispatch('user/resetToken')
                    // Message.error(error || 'Has Error')
                    next(`/login?redirect=${to.path}`)
                    // NProgress.done()
                }
            }
        }
    } else {
    /* has no token*/

        if (whiteList.indexOf(to.path) !== -1) {
            // in the free login whitelist, go directly
            next()
        } else {
            // other pages that do not have permission to access are redirected to the login page.
            next(`/login?redirect=${to.path}`)
            // NProgress.done()
        }
    }
})

router.afterEach(() => {
    // finish progress bar
    // NProgress.done()
})
router.onError((err) => {
    const pattern = /Loading chunk (\d)+ failed/g
    const isChunkLoadFailed = err.message.match(pattern)
    if (isChunkLoadFailed) {
        const chunkBool = sessionStorage.getItem('chunkError')
        const nowTimes = Date.now()
        if (chunkBool === null || chunkBool && nowTimes - parseInt(chunkBool) > 60000) { // 路由跳转报错,href手动跳转
            sessionStorage.setItem('chunkError', 'reload')
            const targetPath = routers.history.pending.fullPath
            window.location.href = window.location.origin + targetPath
        } else if (chunkBool === 'reload') { // 手动跳转后依然报错,强制刷新
            sessionStorage.setItem('chunkError', Date.now())
            window.location.reload(true)
        }
    }
})
